// extracted by mini-css-extract-plugin
module.exports = {"newscontent-box":"dn","newscontentBox":"dn"};